import { TooltipHoverTarget } from "@repo/ui/tooltip/hoverTarget";
import { SimpleTooltip } from "@repo/ui/tooltip/simpleTooltip";
import { TooltipTrigger } from "@repo/ui/tooltip/tooltipTrigger";
import type { FC } from "react";

export type NodeChangeDotVariant = "draft" | "suggestion";

export interface NodeChangeDotProps {
  entity: "section" | "criterion" | "outcome" | "summary template";
  /** When false, renders an aria-hidden placeholder of the same size to keep adjacent controls from shifting. */
  isVisible: boolean;
  /**
   * Visual variant. `"draft"` (default) is the amber unpublished-change mark.
   * `"suggestion"` is the indigo mark used to flag criteria the agent has an
   * open saved proposal for.
   */
  variant?: NodeChangeDotVariant;
}

export const NodeChangeDot: FC<NodeChangeDotProps> = ({
  entity,
  isVisible,
  variant = "draft",
}) => {
  if (!isVisible) {
    return <span aria-hidden className="block size-2 shrink-0" />;
  }

  if (variant === "suggestion") {
    return (
      <TooltipTrigger>
        <TooltipHoverTarget shape="circle">
          <span className="block size-2 shrink-0 rounded-full bg-indigo-500" />
        </TooltipHoverTarget>
        <SimpleTooltip>
          The agent has a suggestion for this {entity}.
        </SimpleTooltip>
      </TooltipTrigger>
    );
  }

  return (
    <TooltipTrigger>
      <TooltipHoverTarget shape="circle">
        <span className="block size-2 shrink-0 rounded-full bg-amber-500" />
      </TooltipHoverTarget>
      <SimpleTooltip>This {entity} has unpublished changes.</SimpleTooltip>
    </TooltipTrigger>
  );
};
